import React, {Fragment, useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import b_ from 'b_';

import {useRumCounter} from 'client/common/utils/rum';
import {useUser} from 'client/common/contexts/user';
import {sendGoal, sendParams} from 'client/common/utils/metrika';
import {PollLandingGoal, PollLandingParam} from 'client/common/types/metrika';

import I18N from 'assets/i18n/poll-landing';

import Header from './components/header';
import {headerMeaningfulSelector} from './components/header/header';

import CallToAction from './components/call-to-action';
import Cards from './components/cards';
import Footer from './components/footer';
import StatusMessage from './components/status-message';

import {StatusCode, SUPPORTED_STATUS_CODES} from './types';
import './poll-landing.css';

const i18n = I18N.page;
const b = b_.with('poll-landing');

export default function PollLanding() {
    const user = useUser();

    useRumCounter({
        page: 'quicksurvey.poll_landing',
        meaningfulPaintSelector: headerMeaningfulSelector,
        testBuckets: user?.testBuckets ?? []
    });

    const [code, setCode] = useState<StatusCode>();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const statusCode = params.get('status') as StatusCode;

        if (statusCode && SUPPORTED_STATUS_CODES.includes(statusCode)) {
            setCode(statusCode);

            sendParams([PollLandingParam.Status, statusCode]);
            sendGoal(PollLandingGoal.Render);
        }
    }, []);

    return (
        <Fragment>
            <Helmet>
                <title>{i18n.title}</title>
            </Helmet>
            <div className={b()}>
                <div className={b('header')}>
                    <Header />
                </div>
                <div className={b('status-message')}>{code && <StatusMessage code={code} />}</div>
                <div className={b('call-to-action')}>
                    <CallToAction />
                </div>
                <div className={b('cards')}>
                    <Cards />
                </div>
                <div className={b('footer')}>
                    <Footer />
                </div>
            </div>
        </Fragment>
    );
}
